import type { Entitlements } from './schemas/plans';

export type { Entitlements } from './schemas/plans';

/**
 * `anonymous` = no account (identified by an anonymous cookie),
 * `free` = registered account without subscription, `pro` = paid subscription.
 */
export const PLANS = ['anonymous', 'free', 'pro'] as const;
export type Plan = (typeof PLANS)[number];

export const PLAN_LABELS: Record<Plan, string> = {
  anonymous: 'Ohne Konto',
  free: 'Kostenlos',
  pro: 'Pro',
};

/**
 * Default plan limits. Operators can override the monthly analysis counts via
 * environment variables; the web app shows these defaults until the server
 * configuration has loaded.
 */
export const DEFAULT_ENTITLEMENTS: Readonly<Record<Plan, Entitlements>> = {
  anonymous: {
    monthlyAnalyses: 3,
    savedListingsMax: 0,
    compareMax: 0,
    savedSearchesMax: 0,
    ownedCarsMax: 0,
    history: false,
    pdfExport: false,
    negotiationHelp: false,
    saleContract: false,
    listingText: false,
    carLog: false,
    monthlyCosts: false,
    reminders: false,
    huReminder: false,
    photoAnalysis: false,
    showAds: true,
  },
  free: {
    monthlyAnalyses: 10,
    savedListingsMax: 5,
    compareMax: 3,
    savedSearchesMax: 0,
    ownedCarsMax: 1,
    history: false,
    pdfExport: false,
    negotiationHelp: false,
    saleContract: false,
    listingText: false,
    carLog: false,
    monthlyCosts: false,
    reminders: false,
    huReminder: true,
    photoAnalysis: false,
    showAds: true,
  },
  pro: {
    monthlyAnalyses: 300,
    savedListingsMax: 500,
    compareMax: 6,
    savedSearchesMax: 50,
    ownedCarsMax: 10,
    history: true,
    pdfExport: true,
    negotiationHelp: true,
    saleContract: true,
    listingText: true,
    carLog: true,
    monthlyCosts: true,
    reminders: true,
    huReminder: true,
    photoAnalysis: true,
    showAds: false,
  },
};
